import { render, staticRenderFns } from "./TeacherAppraiser.vue?vue&type=template&id=87e877de"
import script from "./TeacherAppraiser.vue?vue&type=script&lang=js"
export * from "./TeacherAppraiser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports